import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { HasPagination, PaginatorModel } from '../../models/paginator.model';
import { environment } from '../../../environments/environment';
import { handleError } from '../../core/tools/handle-error';

@Injectable({
  providedIn: 'root',
})
export class InfoService {
  private url = "http://44.227.128.156:4201/api/controlador/findAllControladorData";

  private readonly http = inject(HttpClient);

  findAll(params?: HttpParams): Observable<any> {
    return this.http
      .get<any>(this.url, { params })
      .pipe(catchError((err) => handleError(err)));
  }
}
